import { Component, OnInit } from '@angular/core';
import { MDBModalRef } from 'angular-bootstrap-md';

@Component({
  selector: 'app-waitingwhite-dialog',
  templateUrl: './waitingwhite-dialog.component.html',
  styleUrls: ['./waitingwhite-dialog.component.scss']
})
export class WaitingwhiteDialogComponent implements OnInit {

  constructor(public modalRef: MDBModalRef) { 
    
  }
  
  ngOnInit() {
  }

}
